
import React from 'react';
import { connect } from 'react-redux';
import { tennisMarketSettings } from '../../../../selectors/marketSettings';
import MarketSettings from '..';
import { PERMISSIONS } from '../../../../constants';
import { aGetTennisMarketSettingsRequest, aUpdateTennisOddsDisabledStatus, aUpdateTennisResultsDisabledStatus } from '../../../../reducers';
import { aClearTennisMarketSettings } from '../../../../reducers/marketSettings';

const mapToProps = (state) => ({
  marketSettings: tennisMarketSettings(state),
});

const actionsToProps = (dispatch) => ({
  getMarketSettings: (payload) => dispatch(aGetTennisMarketSettingsRequest(payload)),
  updateOddsDisable: (payload) => dispatch(aUpdateTennisOddsDisabledStatus(payload)),
  updateResultsDisable: (payload) => dispatch(aUpdateTennisResultsDisabledStatus(payload)),
  clearMarketSettings: (payload) => dispatch(aClearTennisMarketSettings(payload)),
});

const TennisMarketSettings = (props) => (
  <MarketSettings
    getMarketSettings={props.getMarketSettings}
    updateOddsDisable={props.updateOddsDisable}
    updateResultsDisable={props.updateResultsDisable}
    clearMarketSettings={props.clearMarketSettings}
    marketSettings={props.marketSettings}
    oddsDisableEnableMarketPermission={
      PERMISSIONS.TENNIS_MARKETSETTINGS_MAINMARKETS_ODDS_DISABLE_ENABLE
    }
    resultsDisableEnableMarketPermission={
      PERMISSIONS.TENNIS_MARKETSETTINGS_MAINMARKETS_RESULTS_DISABLE_ENABLE
    }
  />
);

export default connect(mapToProps, actionsToProps)(TennisMarketSettings);
